import React, {PureComponent} from "react";
import axios from "axios";
import GridItem from "./GridItem/GridItem";
import SearchItem from "./SearchItem/SearchItem";
import NoContent from "../NoContent/NoContent";
import Analytics from "../../libs/analytics";
import * as actionTypes from "../../store/actions";
import store from "../../store/store";
import "./Grid.scss";
import Dots from "../../ui/Dots/Dots";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";

const Loading = () => (
    <div className="col-xs-12 d-flex loading justify-content-center">
        <Dots/>
    </div>
)

class Grid extends PureComponent {
    constructor(props) {
        super(props);
        const {termToSearch, currentAsset} = props;
        this.state = {
            assets: [],
            page: 0,
            currentAsset: currentAsset,
            searchTerm: termToSearch,
            loading: false,
            enableLoading: true
        }
    }

    storeSubscribeGrid = () => {
        const storeState = store.getState();
        if (storeState.event === actionTypes.PLAYER_EVENT) {
            if (storeState.player_event !== 'tvp:media:videoended') return;
            let index = 0;
            const assets = this.state.assets;
            const assetsQty = assets.length;
            for (let i = 0; i < assetsQty; i++) {
                if (assets[i].id == this.state.currentAsset) {
                    if (i === (assetsQty - 1))
                        index = 0;
                    else
                        index = ++i;
                }
            }
            const asset = assets[index];
            if (asset.entityType === 1 && assetsQty === 1) return;
            store.dispatch({
                type: actionTypes.UPDATE_ASSET,
                asset: asset
            });


        } else if (storeState.event === actionTypes.UPDATE_ASSET) {
            setTimeout(this.setState({
                currentAsset: storeState.asset.id
            }), 200);

        }

    }

    componentDidMount() {
        this.loadMoreAssets();
        window.addEventListener("scroll", this.onScroll);
        store.subscribe(this.storeSubscribeGrid);
    }

    componentDidUnmount() {
        window.removeEventListener("scroll", ()=>{
            this.onScroll();
        });
    }

    loadMoreAssets = () => {
        const {loading} = this.state;
        if (loading) return;
        this.setState({loading: true});
        const {page} = this.state;
        const pageToLoad = page + 1;

        this.s = `
                {
                  content(per_page: 12, page : ${pageToLoad}) {
                    total
                    items {
                      content_id
                      title
                      uri_stem
                      description
                      page_url
                      asset{
                        asset_type
                        youtube{
                            youtube_id
                            height
                            width
                            duration
                            thumbnail
                            youtube_url
                        }
                        photo{
                          sources{
                            height
                            width
                            url
                          }
                          thumbnails{
                            url
                            height
                            width
                          }
                        }
                        video{
                          thumbnails{
                            url
                            height
                            width
                          }
                          sources{
                            hls
                            dash
                            mp4{
                              height
                              width
                              url
                            }
                          }
                        }
                      }
                      creator{
                        creator_id
                        full_name
                        thumbnail
                      }
                      products{
                         product_id,
                         title,
                         image,
                         link,
                         price,
                         sale_price
                      }
                      attributes{
                        code,
                        value
                      }
                      content_type,
                      creation_date
                    }
                  }
                }
                `;
        const requestQuery = this.s;

        axios.post(ClientConfigurationHelper.getContentSearchUrl(), {query: requestQuery}, {withCredentials: true}).then(response => {

            const items = response.data.data.content.items.map(item => {

                const attribute = item.attributes?.find?.(f => f.code === "category");
                const category = attribute?.value[0] || "";
                const assetType = {
                    'youtube': 'youtube',
                    'video': 'mp4',
                    'photo': 'photo'
                };
                const buildVideoSrc = video =>{
                    return {
                        src: video.url,
                        file: video.url,
                        mime: "video/mp4",
                        height: video.height,
                        width: video.width
                    }
                }
                const buildSources = asset =>{
                    const {asset_type} = asset;
                    if(asset_type === "youtube"){
                        return {videoId: asset.youtube.youtube_id, thumbnailUrl: asset.youtube.thumbnail}
                    }else if(asset_type === "video"){
                        return {hls: asset.video.hsl, dash: asset.video.dash, sources: asset.video.sources.mp4.map(buildVideoSrc), thumbnails: asset.video.thumbnails}
                    }else{
                        return {sources: asset.photo.sources, thumbnails: asset.photo.thumbnails}
                    }
                }
                const asset = {
                    type: assetType[item?.asset?.asset_type],
                    ...buildSources(item?.asset)
                }
                return {
                    title: item.title,
                    creator: item.creator,
                    uri_stem: item.uri_stem,
                    user_id: item?.creator?.creator_id,
                    description: item.description,
                    id: item.content_id,
                    content_id: item.content_id,
                    category: category,
                    entityType: item.content_type === "video" ? 1 : 7,
                    products: item?.products || [],
                    asset: asset
                };
            });
            const total = response.data.data.content.total || 0;

            
            if (typeof setTotal === "function" && pageToLoad === 1) {
                setTotal(total);
            }

            const currenItemsLoaded = page * 12;
            if(currenItemsLoaded > total){
                this.setState({enableLoading: false});
            }
            this.setAssetsFromResponse(items);
        }).catch(err => {
            console.log('error loading grid items', err);
        });
    }

    onScroll = () => {
        const {loading, enableLoading} = this.state;
        if (loading) return;

        const scrollTo = window.pageYOffset || document.documentElement.scrollTop;
        const newWindowHeight = document.documentElement.offsetHeight - window.innerHeight;
        const percentDocument = (scrollTo * 100) / newWindowHeight;
        if (percentDocument > 80 && enableLoading) {
            this.loadMoreAssets();
        }
    }

    setAssetsFromResponse = (data) => {
        const {assets, page, searchTerm} = this.state;
        let newState = {};
        if ((data && data.length)) {
            if (data.length > 0 && this.props.pmEvent && page === 0 && !searchTerm) {
                Analytics.pmEvent(data[0]);
            }
            newState = {
                assets: assets.concat(data),
                page: page + 1
            };
        } else {
            if (page === 0 && this.props.noResultsCallback)
                this.props.noResultsCallback();
        }
        newState.loading = false;
        this.setState(newState);
    }

    getGridItemFromAsset = (asset, key) => {
        const {redirect, lazyLoadingThumbnails} = this.props;
        const {currentAsset, searchTerm} = this.state;
        if(searchTerm){
            return <SearchItem
                asset={asset}
                lazyLoadingThumbnails={lazyLoadingThumbnails}
                key={key}/>;
        }else{
            return <GridItem
                dataTestid="tvp-grid-item"
                asset={asset}
                playing={asset.id === currentAsset}
                redirect={redirect}
                maxDescriptionLines={3}
                lazyLoadingThumbnails={lazyLoadingThumbnails}
                key={key}/>;
        }
    }

    render() {
        const {assets, loading, enableLoading, searchTerm} = this.state;
        const gridItems = assets.map(this.getGridItemFromAsset);
        const {gridTitle} = this.props;
        return (
            <div data-testid="tvp-grid" className="container tvp-grid pb-4">
                <div className="row">
                    {gridTitle && <h1 className="col-12 grid-title text-center">{gridTitle}</h1>}
                </div>
                <div className={"row "+(searchTerm ? "is-search" : "")}>
                    {gridItems}
                    {loading && <Loading/>}
                    {(!enableLoading && searchTerm || (!assets || !assets.length && !loading)) && <NoContent><div className={"no-results"}>No results found.</div></NoContent>}
                </div>
            </div>
        );
    }
}

Grid.defaultProps = {
    gridTitle: "Watch the latest",
    currentAsset: 0,
    redirect: true,
    pmEvent: true,
    noResultsCallback: ()=>{},
    showNoResults: false,
    lazyLoadingThumbnails: true
};

export default Grid;
